/**
 * Preseturile Stage 1/2/3: schimbă doar hărțile și piesele. Câștigul de putere îl calculează modelul motorului
 * (aer, temperatură, λ, avans, detonație), nu procente scrise aici.
 */
import type { PowertrainInfo } from './info';
import { STOCK_PARTS, type Ecu, type Parts } from './types';

export type Stage = 0 | 1 | 2 | 3;

export function applyStage(stage: Stage, stock: Ecu, pt: PowertrainInfo): { ecu: Ecu; parts: Parts } {
  const ecu: Ecu = JSON.parse(JSON.stringify(stock));
  const parts: Parts = { ...STOCK_PARTS };
  if (stage === 0) return { ecu, parts };
  const turbo = pt.turbo;
  const diesel = pt.fuel === 'diesel';
  const boostAdd = [0, 0.25, 0.4, 0.75][stage];
  const limitMul = [1, 1.3, 1.45, 1.8][stage];
  if (stage >= 2) { parts.exhaust = 0.8; parts.intercooler = 0.8; parts.intake = 1.03; }
  if (stage >= 3) { parts.turboScale = turbo ? 1.35 : 1; parts.injectors = 1.45; parts.forged = true; parts.clutch = 1.6; parts.octane = 98; }
  ecu.rpm.forEach((rpm, i) => {
    if (turbo) {
      // fără presiune în plus sub turația la care turbo-ul abia se umflă
      const ramp = Math.min(1, Math.max(0, (rpm - pt.spoolRpm[0]) / (pt.spoolRpm[1] - pt.spoolRpm[0])));
      ecu.boostBar[i] = +(stock.boostBar[i] + boostAdd * ramp).toFixed(2);
    }
    ecu.torqueLimitNm[i] = Math.round(stock.torqueLimitNm[i] * limitMul);
    if (diesel) {
      ecu.fuel[i] = +(1 + [0, 0.18, 0.28, 0.5][stage]).toFixed(2);
      ecu.lambda[i] = [1.25, 1.18, 1.15, 1.12][stage];
    } else {
      ecu.timingDeg[i] = [0, 1.5, 2, 1][stage];
      ecu.lambda[i] = [0.85, 0.83, 0.82, 0.8][stage];
      if (!turbo) ecu.timingDeg[i] = [0, 2.5, 3, 3][stage];
    }
  });
  ecu.limiterRpm = stock.limiterRpm + (turbo || diesel ? 0 : [0, 200, 300, 400][stage]);
  return { ecu, parts };
}
